import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userService } from '../../services/userService';
import { toastService } from '../../services/toastService';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/buttons/button';
import { ICONS } from '../../constants/imageConstants';
import { useAuthForm } from '../../hooks/useAuthForm';
import PageLayout from '../../components/layout/PageLayout';

const inputClass = 'h-12 placeholder-gray-400 text-sm text-gray-700 font-medium';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const {
    formData,
    submitting,
    error,
    setError,
    showPassword,
    setShowPassword,
    showConfirm,
    setShowConfirm,
    onChange,
    handleSubmit
  } = useAuthForm({ current_password: '', password: '', confirm_password: '' });
  
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  useEffect(() => {
    if (error) {
      toastService.error(error);
      setError('');
    }
  }, [error, setError]);

  const onSubmit = e => {
    handleSubmit(e,
      (data) => userService.changePassword({
        old_password: data.current_password,
        new_password: data.password,
        confirm_password: data.confirm_password,
      }),
      () => {
        toastService.success('Password updated successfully!');
        navigate('/settings');
        return '';
      },
      (data) => {
        if (data.password !== data.confirm_password) return 'New passwords do not match.';
        if (data.password.length < 8) return 'New password must be at least 8 characters long.';
        return null;
      }
    );
  };

  return (
    <PageLayout title="Change Password" showStatus>
      <form onSubmit={onSubmit} className="space-y-5">
        <div className="relative">
          <Input 
            label="Current Password" 
            id="current_password" 
            name="current_password" 
            type={showCurrentPassword ? 'text' : 'password'} 
            value={formData.current_password} 
            onChange={onChange} 
            className={inputClass} 
            placeholder="Enter current password" 
          />
          <button 
            type="button" 
            onClick={() => setShowCurrentPassword(p => !p)} 
            className="absolute bottom-4 right-3 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src={showCurrentPassword ? ICONS.EYE : ICONS.EYE_OFF} alt="Toggle" className="w-5 h-5" />
          </button>
        </div>

        <div className="relative">
          <Input 
            label="New Password" 
            id="password" 
            name="password" 
            type={showPassword ? 'text' : 'password'} 
            value={formData.password} 
            onChange={onChange} 
            className={inputClass} 
            placeholder="Enter new password"
          />
          <button 
            type="button" 
            onClick={() => setShowPassword(p => !p)} 
            className="absolute bottom-4 right-3 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src={showPassword ? ICONS.EYE : ICONS.EYE_OFF} alt="Toggle" className="w-5 h-5" />
          </button>
        </div>

        <div className="relative">
          <Input 
            label="Confirm New Password" 
            id="confirm_password" 
            name="confirm_password" 
            type={showConfirm ? 'text' : 'password'} 
            value={formData.confirm_password} 
            onChange={onChange} 
            className={inputClass} 
            placeholder="Confirm new password"
          />
          <button 
            type="button" 
            onClick={() => setShowConfirm(p => !p)} 
            className="absolute bottom-4 right-3 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src={showConfirm ? ICONS.EYE : ICONS.EYE_OFF} alt="Toggle" className="w-5 h-5" />
          </button>
        </div>

        <div className="pt-4">
          <Button 
            type="submit" 
            vairant="blue"
            fullWidth
            size="lg"
            disabled={submitting}
          >
            {submitting ? 'Updating...' : 'Update Password'}
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

export default ChangePasswordPage;